<span
  class="inline-flex w-fit items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 font-medium"
  [ngClass]="chipClass">
  {{ status() | checkRequestsStatusName }}
</span>
